import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import { useTranslations } from "next-intl";
import CoinSVG from "../../../../../public/Icons/CoinIcons/Coin";
import cn from "@/app/utils/cn";
import NoData from "@/app/components/UI/NoData";
interface SearchableAssetListItem {
  key: string;
  symbol: string;
  displayName: string;
}
interface SearchableAssetListProps<T extends SearchableAssetListItem> {
  items: T[];
  isLogin?: boolean;
  onSelect: (item: T) => void;
  getPrimaryBalance?: (item: T) => React.ReactNode;
  getSecondaryBalance?: (item: T) => React.ReactNode;
  maxHeightClassName?: string;
}
export default function SearchableAssetList(t0) {
  const $ = _c(23);
  const {
    items,
    isLogin,
    onSelect,
    getPrimaryBalance,
    getSecondaryBalance,
    maxHeightClassName: t1
  } = t0;
  const maxHeightClassName = t1 === undefined ? "max-h-96 md:max-h-112" : t1;
  const t = useTranslations();
  let t2;
  if ($[0] !== maxHeightClassName) {
    t2 = cn("customDropDownScrollbar touch-pan-y snap-y snap-start overflow-y-auto", maxHeightClassName);
    $[0] = maxHeightClassName;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("comparison.HEADER.CRYPTO");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <p>{t3}</p>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== isLogin || $[7] !== t) {
    t5 = isLogin && <p>{t("comparison.HEADER.YOUR_FIAT_BALANCE")}</p>;
    $[6] = isLogin;
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className="flex items-center justify-between px-4 py-4 text-xs text-charcoal-600 md:px-6">{t4}{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== getPrimaryBalance || $[13] !== getSecondaryBalance || $[14] !== isLogin || $[15] !== items || $[16] !== onSelect || $[17] !== t) {
    t7 = items.length > 0 ? items.map((item, index) => <a className="cursor-pointer" key={item.key} onClick={() => onSelect(item)}><div className={cn("flex items-center px-4 md:px-6", index === 0 ? "pb-4" : "py-4", items.length > index + 1 ? "border-b border-charcoal-200" : "")}><div className="flex w-full items-center justify-between"><div className="flex items-center gap-x-3"><CoinSVG id={item.symbol} className="h-8 w-8" /><div className="text-sm"><h6 className="text-sm font-semibold text-charcoal-900 md:text-base">{item.displayName}</h6><h6 className="mt-1 text-xs font-medium text-charcoal-600 md:mt-2 md:text-sm">{item.symbol}</h6></div></div>{isLogin && <div dir="ltr"><h6 className="text-sm font-semibold text-charcoal-900 md:text-base">{getPrimaryBalance?.(item)}</h6><p className="mt-1 text-xs font-medium text-charcoal-600 md:mt-2 md:text-sm">{getSecondaryBalance?.(item)}</p></div>}</div></div></a>) : <div className="flex h-full w-full flex-col items-center justify-center gap-3 pb-4 md:pb-6"><NoData text={t("general.NOT_FOUND")} image="/images/not-found.png" width={120} height={139} /></div>;
    $[12] = getPrimaryBalance;
    $[13] = getSecondaryBalance;
    $[14] = isLogin;
    $[15] = items;
    $[16] = onSelect;
    $[17] = t;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t2 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className={t2}>{t6}{t7}</div>;
    $[19] = t2;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}